// extracted by mini-css-extract-plugin
export var buttonLeft = "GallerySlider-module--buttonLeft--f8645";
export var buttonRight = "GallerySlider-module--buttonRight--7d033";
export var fadeInAnimation = "GallerySlider-module--fadeInAnimation--70cc5";
export var sliderContainer = "GallerySlider-module--sliderContainer--66f0b";
export var sliderControls = "GallerySlider-module--sliderControls--7bae1";
export var title = "GallerySlider-module--title--6241c";
export var topRow = "GallerySlider-module--topRow--3a4be";